module.exports = __webpack_public_path__ + "media/backgrounds/bernd-dittrich-9NQmjbE6Y7k-unsplash-b0ad185d.jpg";